import { PropType, defineComponent, watch } from 'vue'

import { CsAccordion, CsGhostButton, CsModal, CsPrimaryButton } from '@sunrise/components'
import { LocationAutocomplete } from '@sunrise/types'

import { FilterId } from '../../ts/service/realEstateService.enum'
import { SearchFilters } from '../../ts/service/realEstateService.interface'
import { useMailAgentStore } from '../../ts/store/mailAgentStoreModule/mailAgentStoreModule'
import { useResultListStore } from '../../ts/store/resultListStoreModule/resultListStoreModule'

import { useResultListFilter } from '../../composables/useResultListFilter'
import MsFilterEnhanced from '../MsFilterEnhanced/MsFilterEnhanced.vue'
import MsFilterLocationArea from '../MsFilterLocationArea/MsFilterLocationArea.vue'
import MsFilterMinMax from '../MsFilterMinMax/MsFilterMinMax.vue'
import { FlexDirection } from '../MsFilterPropertyType/MsFilterPropertyType.enum'
import MsFilterPropertyType from '../MsFilterPropertyType/MsFilterPropertyType.vue'
import { FilterCategoryKey } from '../MsResultListFilter/MsResultListFilter.enum'

export default defineComponent({
    name: 'MsResultListFilterModal',
    components: {
        MsFilterPropertyType,
        MsFilterEnhanced,
        MsFilterMinMax,
        MsFilterLocationArea,
        CsAccordion,
        CsModal,
        CsPrimaryButton,
        CsGhostButton,
    },
    props: {
        isVisible: {
            type: Boolean,
            required: true,
        },
        totalCount: {
            type: Number,
            required: true,
        },
        locationLevels: { type: Array as PropType<LocationAutocomplete.LOCATION_LEVELS[]>, required: true },
        searchFilters: { type: Object as PropType<SearchFilters>, required: true },
        isLoading: { type: Boolean, default: false },
    },
    emits: ['closeModal', 'resultsButtonClicked'],
    setup(props, { emit }) {
        const resultListStore = useResultListStore()
        const mailAgentStore = useMailAgentStore()

        const {
            filtersForSelectedEstate,
            filterMinMaxValues,
            hasValuesForFilterId,
            onUpdateMinMaxValue,
            updateSearchFilters,
        } = useResultListFilter(props.searchFilters)

        const initialValues = {
            sr: resultListStore.searchParams.sr?.toString(),
            mailAgentTags: {
                locationName: mailAgentStore.tags.locationName,
                estateType: mailAgentStore.tags.estateType,
                searchRadius: mailAgentStore.tags.searchRadius,
            },
        }

        function onClickReset() {
            resetFilter()
            resetMailAgent()
        }

        function resetFilter(): void {
            resultListStore.resetPage()
            resultListStore.resetFilter()
            resultListStore.searchParams.sr = initialValues.sr
        }

        function resetMailAgent() {
            mailAgentStore.resetFilterTags()
            mailAgentStore.$patch({
                tags: {
                    estateType: initialValues.mailAgentTags.estateType,
                    searchRadius: initialValues.mailAgentTags.searchRadius,
                },
            })
        }

        function emitClosedModalEvent(): void {
            emit('closeModal')
        }

        function emitResultsButtonClicked(): void {
            setTimeout(() => {
                emit('resultsButtonClicked')
            }, 100)
        }

        watch(
            () => props.searchFilters,
            (searchFilters) => {
                updateSearchFilters(searchFilters)
            },
        )

        return {
            FlexDirection,
            filtersForSelectedEstate,
            filterMinMaxValues,
            FilterId,
            FilterCategoryKey,
            emitResultsButtonClicked,
            onClickReset,
            hasValuesForFilterId,
            onUpdateMinMaxValue,
            emitClosedModalEvent,
        }
    },
})
